import { useQuery } from '@apollo/client';
import { Spacer, Text } from '@loomhq/lens';
import _take from 'lodash/take';
import React from 'react';
import { useSelector } from 'react-redux';

import { MemberPropertyEnum } from 'constants/memberProperties';
import GetSuggestedStreams from 'creators/follows/GetSuggestedStreams.graphql';
import { selectCurrentUser } from 'selectors/user';

import { useMemberProperty } from 'hooks/memberProperties';

import SuggestedProfileFollow from './SuggestedProfileFollow';
import SuggestedTagFollow from './SuggestedTagFollow';

import styles from '../styles.module.less';

const MAX_SUGGESTED_STREAMS = 5;

const SuggestedFollows = ({
  followedProfiles,
  followedTags,
  ProfileLink,
  TagLink,
}) => {
  const currentUser = useSelector(selectCurrentUser);
  const followedProfileIds = new Set(followedProfiles.map(p => p.user.id));
  const followedTagNames = new Set(followedTags.map(t => t.name));

  const { value: declinedStreams } = useMemberProperty(
    MemberPropertyEnum.DECLINED_SUGGESTED_FOLLOW_STREAMS
  );

  const { loading, data: suggestedFollows } = useQuery(GetSuggestedStreams, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  if (loading && !suggestedFollows?.result) {
    return null;
  }

  const { tags, profiles } = suggestedFollows.result;

  // Filter out duplicates and limit suggested profiles to max length
  const suggestedProfiles = _take(
    profiles.filter(
      profile =>
        !followedProfileIds.has(profile.user.id) &&
        String(currentUser.id) !== profile.user.id
    ),
    MAX_SUGGESTED_STREAMS - followedProfiles?.length
  );

  // Filter out duplicates and limit suggested tags to max length
  const suggestedTags = _take(
    tags.filter(tag => !followedTagNames.has(tag.name)),
    MAX_SUGGESTED_STREAMS - followedTags?.length
  );

  if (!suggestedProfiles.length && !suggestedTags.length) {
    return null;
  }

  return (
    <>
      <div className={styles.librariesHeading}>
        <Spacer bottom="small" left="xsmall">
          <Text fontWeight="medium" color="bodyDimmed">
            Suggested
          </Text>
        </Spacer>
      </div>

      {suggestedProfiles?.map(profile => (
        <SuggestedProfileFollow
          key={profile.user.id}
          profile={profile}
          ProfileLink={ProfileLink}
          declinedStreams={declinedStreams}
        />
      ))}

      {suggestedTags?.map(tag => (
        <SuggestedTagFollow
          key={tag.name}
          tag={tag}
          TagLink={TagLink}
          declinedStreams={declinedStreams}
        />
      ))}
    </>
  );
};

export default SuggestedFollows;
